// import React from 'react'

// const Footer = () => {
//     return (
//         <div style={{textAlign:'center',marginBottom: 10}}>
//             Made By Harsh{" "}
//         </div>
//     )
// }

// export default Footer







const Footer = () => {
    return (
      <div
        style={{
          textAlign: "center",
          marginBottom: 10,
        }}
      >
        Made with ♥ by{" "}
        <a
          // href="https://www.youtube.com/roadsidecoder"
          style={{ cursor: "pointer" }}
        >
          HARSH
        </a>
      </div>
    );
  };
  
  export default Footer;